import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA029_Request,
  IAPI_STA029_Response,
  IAPI_STA041_Request,
  IAPI_STA041_Response,
} from "../../../type/apiType";

// 退職予定者一覧参照
const httpAPI_STA029 = async (
  param: IAPI_STA029_Request
): Promise<IAPI_STA029_Response> => {
  let res = await http.post(ApiUrl.API_STA029, {
    ...param,
  });

  return res.data;
};

// 退職届等一時保存データ削除
const httpAPI_STA041 = async (
  param: IAPI_STA041_Request
): Promise<IAPI_STA041_Response> => {
  let res = await http.post(ApiUrl.API_STA041, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA029, httpAPI_STA041 };
